'use client';
import Image from 'next/image';
import type { ArbitraryTypedObject } from '@portabletext/types';
import { PortableTextBlock } from '@sanity/types';
import { getSanityImageUrl } from '@/libs/sanity/client';
import CardSlide from '@/components/CardSlide';
import { BlurInH2 } from '@/components/eldora-ui/blur-in-h2';
import { PortableTextWrapper } from './PortableTextWrapper';
import React from 'react';

type PortableTextContent =
  | PortableTextBlock
  | ArbitraryTypedObject
  | (PortableTextBlock | ArbitraryTypedObject)[];

type ContentSlideAndImageProps = {
  anchor?: string;
  image?: { asset: { _ref: string } };
  firstContent?: PortableTextContent;
  secondContent?: PortableTextContent;
  thirdContent?: PortableTextContent;
  cardSlidesTitle?: string;
  title?: string;
  cardSlides?: any;
};

const ContentSlideAndImage: React.FC<ContentSlideAndImageProps> = ({
  anchor,
  image,
  title,
  firstContent,
  secondContent,
  thirdContent,
  cardSlides,
  cardSlidesTitle,
}) => (
  <section id={anchor} className="max-w-8xl mx-auto mt-12 scroll-mt-[150px]">
    {title && <BlurInH2>{title}</BlurInH2>}
    {firstContent && <PortableTextWrapper value={firstContent} />}
    {cardSlidesTitle && (
      <p className="text-primary text-lg font-medium pb-4">{cardSlidesTitle}</p>
    )}
    {cardSlides && (
      <div className="mb-4 sm:mb-10">
        <CardSlide cardSlides={cardSlides} />
      </div>
    )}
    {secondContent && <PortableTextWrapper value={secondContent} />}
    <div className="grid grid-cols-1 lg:grid-cols-12 justify-between mb-2 gap-4 mt-4">
      <div className="col-span-12 lg:col-span-7">
        {thirdContent && <PortableTextWrapper value={thirdContent} />}
      </div>
      <div className="col-span-12 lg:col-span-5 mt-2 mb-8">
        {image && (
          <Image
            src={getSanityImageUrl(image)}
            alt={title || 'Content image'}
            className="object-cover h-full w-full"
            width={1000}
            height={2000}
          />
        )}
      </div>
    </div>
  </section>
);

export default ContentSlideAndImage;
